import {Component} from "@angular/core";

@Component({
    selector: "fui-breadcrumbs",
    styleUrls: ["./breadcrumbs.component.scss"],
    templateUrl: "./breadcrumbs.component.html"
})
export class FUIBreadcrumbsComponent {
    constructor() {

    }
}
